// Default order data
export const defaultOrderData = {
    eventName: "",
    address: "",
    date: [],
    floor: undefined,
    room: "",
    customer: "",
    receiver: "",
    recipient: undefined,
    phone: "",
    paymentMethod: null,
    code: "",
    selectedDate:"",
    time: ""
}
// Minimum order price
export const minOrderPrice = 10000;
// Sample transport price
export const transportPrice = 385;